import { create } from 'zustand'
import { SharedSlice, createSharedSlice } from '../../../slice'
import createPunchesByStaffSlice, {
  PunchesByStaffSlice,
} from './punches-by-staff/slice'
import createStaffClocksSlice, { StaffClocksSlice } from './staff-clocks/slice'
import createTimeclockSharedSlice, { TimeclockSharedSlice } from './slice'

const useTimeclockStore = create<
  PunchesByStaffSlice & StaffClocksSlice & TimeclockSharedSlice & SharedSlice
>()((...props) => ({
  ...createSharedSlice(...props),
  ...createTimeclockSharedSlice(...props),
  ...createPunchesByStaffSlice(...props),
  ...createStaffClocksSlice(...props),
}))

export default useTimeclockStore
